/** The authoring contract stores cm/cm²; changing the preview unit never changes the draft. */
export const formatResizableMeasurement = (
    value: number | null | undefined,
    unit: { label: string; ratio: number },
    locale: string,
    missing: string,
    area = false
): string => {
    if (value == null || !Number.isFinite(value)) return missing;
    const converted = value / (area ? unit.ratio ** 2 : unit.ratio);
    return `${converted.toLocaleString(locale, { maximumFractionDigits: 6 })} ${unit.label}${area ? '²' : ''}`;
};
